import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../icon';

const DownloadLink = ({ href, downloadText }) => (
  <div className="figure-panel-download">
    <Anchor
      icon={Icon.Download}
      href={href}
      iconPlacement="left"
      hasBackgroundColor={false}
      target="_blank"
      className="call-to-action"
    >
      {downloadText}
    </Anchor>
  </div>
);

DownloadLink.propTypes = {
  href: PropTypes.string.isRequired,
  downloadText: PropTypes.string.isRequired,
};

export default DownloadLink;
